import ConnectionClient from './ConnectionClient';
import { CommonConnectionModel } from '../../domain/connection/ConnectionDomains';
import HttpClient from '../../gateway/HttpClient';
import { notBlank, notUndefined } from '../../util/Assert';
import HttpMethod from '../../constant/HttpMethod';
import { ConnectionMethods } from '../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import { ActionType } from '../../constant/Constants';
import SelectQuery = query.SelectQuery;

class NestConnectionClient implements ConnectionClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public save(connection: CommonConnectionModel): Promise<void> {
    notUndefined(connection, 'Connection cannot be undefined');
    const dto = { id: connection.name, connection: connection };
    return this.httpClient.execute(HttpMethod.POST, ConnectionMethods.SAVE, dto);
  }

  public async remove(id: string): Promise<void> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.DELETE, `${ConnectionMethods.REMOVE}/${id}`);
  }

  public deploy(id: string): Promise<void> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.POST, `${ConnectionMethods.DEPLOY}/${id}`);
  }

  public undeploy(id: string): Promise<void> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.POST, `${ConnectionMethods.UNDEPLOY}/${id}`);
  }

  public exist(id: string): Promise<boolean> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.GET, `${ConnectionMethods.EXIST}/${id}`);
  }

  public count(query: SelectQuery): Promise<number> {
    notUndefined(query, 'Query cannot be undefined');
    return this.httpClient.execute(HttpMethod.POST, ConnectionMethods.COUNT, query);
  }

  public bulkAction(ids: string[], type: ActionType): Promise<{ id: string; error: any }[]> {
    const payload = { ids, type };
    return this.httpClient.execute(HttpMethod.POST, ConnectionMethods.BULK_ACTION, payload);
  }
}

export default NestConnectionClient;
